import { usageUnitLockPeriodStatusEnumList } from '../../../components/AgGrid/enumLists'

const usageUnitLockPeriodStatusValueGetter = (props) => {
  const { value } = props
  const status = value && value === 'NOT_LOCKED' ? 'NOTLOCKED' : 'LOCKED'
  return usageUnitLockPeriodStatusEnumList(status)
}

export default usageUnitLockPeriodStatusValueGetter
